import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-dental-chart',
    templateUrl: './dental-chart.component.html',
    styleUrls: ['./dental-chart.component.css']
})
export class DentalChartComponent implements OnChanges {

    @Input() formGroup!: FormGroup;        // Parent form reference
    @Input() controlName = 'diagram';      // Default control name
    @Input() initialSelected: string[] = [];// Pre-selected teeth
    @Input() selectionMode: 'S' | 'M' = 'S';// Single or Multiple selection
    @Output() selectionChange = new EventEmitter<string[]>(); // Notify parent
    tooltipPosition = { x: 0, y: 0 };

    teeth: { [key: string]: boolean } = {
        '11': false, '12': false, '13': false, '14': false, '15': false, '16': false, '17': false, '18': false,
        '21': false, '22': false, '23': false, '24': false, '25': false, '26': false, '27': false, '28': false,
        '31': false, '32': false, '33': false, '34': false, '35': false, '36': false, '37': false, '38': false,
        '41': false, '42': false, '43': false, '44': false, '45': false, '46': false, '47': false, '48': false
    };
    hoveredTooth: string | null = null;
    toothNames: { [key: string]: string } = {
        '11': 'Upper Right Central Incisor',
        '12': 'Upper Right Lateral Incisor',
        '13': 'Upper Right Canine',
        '14': 'Upper Right First Premolar',
        '15': 'Upper Right Second Premolar',
        '16': 'Upper Right First Molar',
        '17': 'Upper Right Second Molar',
        '18': 'Upper Right Third Molar',
        '21': 'Upper Left Central Incisor',
        '22': 'Upper Left Lateral Incisor',
        '23': 'Upper Left Canine',
        '24': 'Upper Left First Premolar',
        '25': 'Upper Left Second Premolar',
        '26': 'Upper Left First Molar',
        '27': 'Upper Left Second Molar',
        '28': 'Upper Left Third Molar',
        '31': 'Lower Left Central Incisor',
        '32': 'Lower Left Lateral Incisor',
        '33': 'Lower Left Canine',
        '34': 'Lower Left First Premolar',
        '35': 'Lower Left Second Premolar',
        '36': 'Lower Left First Molar',
        '37': 'Lower Left Second Molar',
        '38': 'Lower Left Third Molar',
        '41': 'Lower Right Central Incisor',
        '42': 'Lower Right Lateral Incisor',
        '43': 'Lower Right Canine',
        '44': 'Lower Right First Premolar',
        '45': 'Lower Right Second Premolar',
        '46': 'Lower Right First Molar',
        '47': 'Lower Right Second Molar',
        '48': 'Lower Right Third Molar'
    };
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['initialSelected'] && this.initialSelected.length > 0) {
            this.initialSelected.forEach(tooth => this.teeth[tooth] = true);
            this.updateForm();
        }
    }

    toggleSelectionMode() {
        this.selectionMode = this.selectionMode === 'S' ? 'M' : 'S';

        if (this.selectionMode === 'S') {
            const selected = this.getSelectedTeeth();
            if (selected.length > 1) {
                Object.keys(this.teeth).forEach(k => this.teeth[k] = false);
                this.teeth[selected[0]] = true;
                this.updateForm();
            }
        }
    }

    handleToothClick(toothNumber: string, event?: MouseEvent) {
        if (this.selectionMode === 'S') {
            Object.keys(this.teeth).forEach(k => this.teeth[k] = false);
            this.teeth[toothNumber] = true;
        } else {
            this.teeth[toothNumber] = !this.teeth[toothNumber];
        }

        // Update tooltip if event is provided
        if (event) this.updateTooltipPosition(event);

        this.updateForm();
    }

    onToothHover(tooth: string, event?: MouseEvent) {
        this.hoveredTooth = tooth;
        if (event) this.updateTooltipPosition(event);
    }

    onToothHoverEnd(teeth) {
        this.hoveredTooth = null;
        this.tooltipPosition = { x: 0, y: 0 };
    }

    private updateTooltipPosition(event: MouseEvent) {
        this.tooltipPosition.x = event.offsetX + 10;
        this.tooltipPosition.y = event.offsetY + 10;
    }

    private getSelectedTeeth(): string[] {
        return Object.keys(this.teeth).filter(key => this.teeth[key]);
    }

    private updateForm() {
        const selected = this.getSelectedTeeth();
        if (this.formGroup && this.formGroup.controls[this.controlName]) {
           this.formGroup?.controls[this.controlName]?.setValue(selected.join(','));
        }
        this.selectionChange.emit(selected);
    }
}